const appConfig = {
	apiUrl: process.env.REACT_APP_FOBIZ_API_ROOT,
	loginUrl: process.env.REACT_APP_FOBIZ_LOGIN_ROOT,
	logoutUrl: process.env.REACT_APP_FOBIZ_LOGOUT_ROOT,
	authenticationUrl: window.location.origin + "/authentication"
}

export default appConfig
